// Lodash
import { sumBy } from 'lodash'

// Dayjs
import dayjs from 'dayjs'

export function invprojection({
    component,
    fulfillment_orders_by_date = [],
    location_id = 1,
}) {
    // Production orders of the component that must increase the stock
    const production_orders = (component?.production_orders ?? []).filter(
        (po) => po.location_id == location_id
    )

    // Production orders of the parents that must decrease the stock of the component
    const parent_production_orders =
        (component?.parents ?? []).flatMap((parent) => {
            return (parent.production_orders ?? []).filter(
                (po) => po.location_id == location_id
            )
        })

    // Purchase orders that must increase the stock
    const purchase_order_line_items =
        (component?.purchase_order_line_items ?? []).filter(
            (i) => i.purchase_order.location_id == location_id
        )

    const projectionEvents = [
        ...purchase_order_line_items.map((i) => {
            return {
                date: i.reception_at,
                quantity: i.quantity_remaining,
                type: 'purchase_order',
                name:
                    'BC°' +
                    i.purchase_order.id +
                    ' - ' +
                    i.purchase_order.reference,
                href: '/purchase_orders/' + i.purchase_order.id,
                location_id: i.purchase_order.location_id,
            }
        }),
        ...parent_production_orders.map((i) => {
            return {
                date: i.starting_at,
                quantity: -i.quantity + i.quantity_completed,
                type: 'parent_production_order',
                name: 'A' + i.id + ' - ' + i.component?.name,
                production_order_status: i.status,
                href: '/assembly/' + i.id,
                purchase_order: i,
            }
        }),
        ...production_orders.map((i) => {
            return {
                date: i.ending_at,
                quantity: i.quantity - i.quantity_completed,
                type: 'production_order',
                name: 'A' + i.id,
                production_order_status: i.status,
                href: '/production_orders/' + i.id,
            }
        }),
        ...fulfillment_orders_by_date.map((i) => {
            return {
                date: i.fulfill_at,
                quantity: -i.remaining_quantity_sum,
                type: 'fulfillment_orders',
            }
        }),
    ]

    return projectionEvents
}

export function component_level_at_date({ component, date = null, location_id = 1 }) {
    // Get all projection events of the component
    const projectionEvents = invprojection({
        component,
        location_id,
    })

    // Set to today if date is missing
    date = date ?? dayjs().format('YYYY-MM-DD')

    // Get initial level of the component
    let initialLevel =
        component?.invlevels?.find(
            (invlevel) =>
                invlevel.location_id === location_id && invlevel.invtype === 'physical'
        )?.invlevel ?? 0

    // Get all projection events before the date
    const projectionEventsBeforeDate = projectionEvents.filter(
        (event) => event.date <= date
    )

    // Sum all quantities of the projection events before the date
    const projectionQuantityBeforeDate = sumBy(
        projectionEventsBeforeDate,
        'quantity'
    )

    return initialLevel + projectionQuantityBeforeDate
}
